

exports.__esModule = true;
exports.$xoSidebarAddBankPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-bank/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
    tag: 'xo-sidebar-add-bank-page',
    template: _template2['default'],
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        $scope.token = _angular.$rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            done: function done() {
                _uiRouter.$state.go('checkout.review');
            }
        };
    }]
});

angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
_angular.$rootScope;

_squid.$Component;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-bank/directive.js
// module id = ./pages/xo-sidebar-add-bank/directive.js
// module chunks = 0